export const SentaiLogoImage = "/Sentai_Logo_2020_RGB_white.svg";
export const LogoVideo = "/hero/SAH2_Phase2_Video_1920x1080.mp4";
export const PosterUrl = "/hero/SAH_Still_Poster_1920x1080_REV.png";
export const HidiveLogoImage = "/HIDIVE_logo.svg";
export const SignupLink = "//mailchi.mp/sentaifilmworks.com/sentai-at-home";
export const EventDate = "August 20";
export const EventDetails = "Sentai at Home is back. Join us for an online event full of special guests, sneak previews, giveaways, and lots more!";
export const EmailSignupText = "Get Notified";

let guestImgPath = "/guests/2021/";

export const guests = [
    {
        name: "Natalie Rial",
        subTitle: "Host / Voice Actress",
        img: guestImgPath + "guest_img_01.png",
    },
    {
        name: "John Swasey",
        subTitle: "Sentai ADR Director",
        img: guestImgPath + "guest_img_02.png",
    },
    {
        name: "Kyle Colby Jones",
        subTitle: "Sentai ADR Director",
        img: guestImgPath + "guest_img_03.png",
    },
    {
        name: "Shannon D. Reed",
        subTitle: "Sentai ADR Director",
        img: guestImgPath + "guest_img_04.png",
    },
    {
        name: "Kenji Kamiyama",
        subTitle: "Director<br/><em>Moribito: Guardian of the Spirit</em>",
        img: guestImgPath + "guest_img_05.png",
    },
    {
        name: "Yohei Kashii",
        subTitle: "Producer<br/><em>Peter Grill</em>",
        img: guestImgPath + "guest_img_06.png",
    },
    {
        name: "Yui Ninomiya",
        subTitle: "\"Luvelia\"<br/><em>Peter Grill</em>",
        img: guestImgPath + "guest_img_07.png",
    },
    {
        name: "Mariya Ise",
        subTitle: "\"Reg\"<br/><em>MADE IN ABYSS</em>",
        img: guestImgPath + "guest_img_08.png",
    },
    {
        name: "Miyu Tomita",
        subTitle: "\"Riko\"<br/><em>MADE IN ABYSS</em>",
        img: guestImgPath + "guest_img_09.png",
    },
    {
        name: "Shiori Izawa",
        subTitle: "\"Nanachi\"<br/><em>MADE IN ABYSS</em>",
        img: guestImgPath + "guest_img_10.png",
    },
    {
        name: "Wataru Watari",
        subTitle: "Creator<br/><em>My Teen Romantic Comedy SNAFU</em>",
        img: guestImgPath + "guest_img_11.png",
    },
    {
        name: "Masazumi Katoh",
        subTitle: "Producer<br/><em>My Teen Romantic Comedy SNAFU</em>",
        img: guestImgPath + "guest_img_12.png",
    },
    {
        name: "Hironori Hoshino",
        subTitle: "Editor<br/><em>My Teen Romantic Comedy SNAFU</em>",
        img: guestImgPath + "guest_img_13.png",
    },
    {
        name: "Yoshitsugu Matsuoka",
        subTitle: "\"Bell Cranel\"<br/><em>Is It Wrong to Try to Pick Up Girls in a Dungeon?</em>",
        img: guestImgPath + "guest_img_14.png",
    },
    {
        name: "Yuki Kaji",
        subTitle: "\"Sora\"<br/><em>Ahiru no Sora</em>",
        img: guestImgPath + "guest_img_15.png",
    },
    {
        img: guestImgPath + "guest_img_16.png",
    },
    {
        img: guestImgPath + "guest_img_17.png",
    },
    {
        img: guestImgPath + "guest_img_18.png",
    },
    {
        img: guestImgPath + "guest_img_19.png",
    },
    {
        img: guestImgPath + "guest_img_20.png",
    },
    {
        img: guestImgPath + "guest_img_21.png",
    },
    {
        img: guestImgPath + "guest_img_22.png",
    },
    {
        img: guestImgPath + "guest_img_23.png",
    },
    {
        img: guestImgPath + "guest_img_24.png",
    },
    {
        img: guestImgPath + "guest_img_25.png",
    },
    {
        img: guestImgPath + "guest_img_26.png",
    },
    {
        img: guestImgPath + "guest_img_27.png",
    },
    {
        img: guestImgPath + "guest_img_28.png",
    },
    {
        img: guestImgPath + "guest_img_29.png",
    },
    {
        img: guestImgPath + "guest_img_30.png",
    },
    {
        img: guestImgPath + "guest_img_31.png",
    },
]

export const articles = [
    {
        img: "/news/SAH_Header04_WelcomeTo_SAH.png",
        title: "Welcome to Sentai at Home!",
        file: "/news/Welcome_to_Sentai_Athome.html"
    },
    {
        img: "/news/SAH_Header05_MultipleDevices.png",
        title: "Watch Anime on Multiple Devices With HIDIVE",
        file: "/news/Watch_On_Multiple_Devices.html"
    },
    {
        img: "/news/SAH_Header06_Top10Naughty.png",
        title: "Top 10 Naughty Anime on HIDIVE",
        file: "/news/Top_10_Naughty_Anime.html"
    },
    {
        img: "/news/SAH_Header02_ClassicAnime.png",
        title: "Top Classic Anime on HIDIVE",
        file: "/news/Top_7_Classic_Anime.html"
    },
    {
        img: "/news/SAH_Header03_WatchParty.png",
        title: "HIDIVE At Home - Watch Along Feature",
        file: "/news/Watch_Party_Hidive.html"
    },
    {
        img: "/news/SAH_Header01_JoinUs.png",
        title: "Sentai at Home is Coming",
        file: "/news/BRING_THE_ANIME_HOME.html"
    },
]

export const scavengerList = [
    {
        label: "Ahiru No Sora Video Conference Background",
        getUrl: "/downloads/AhiruNoSora_ZoomBG-1.jpg"
    },
    {
        label: "MADE IN ABYSS Video Conference Background 1",
        getUrl: "/downloads/MIA_ZoomBG_1.jpg"
    },
    {
        label: "MADE IN ABYSS Video Conference Background 2",
        getUrl: "/downloads/MIA_ZoomBG_2.jpg"
    },
    {
        label: "No Game, No Life Video Conference Background 1",
        getUrl: "/downloads/NGNL_ZoomBG_1.jpg"
    },
    {
        label: "No Game, No Life Video Conference Background 2",
        getUrl: "/downloads/NGNL_ZoomBG_2.jpg"
    },
    {
        label: "No Game, No Life Zero Video Conference Background 1",
        getUrl: "/downloads/NGNL0_ZoomBG_1.jpg"
    },
    {
        label: "Utano Princesama Maji Love Kingdom Video Conference Background",
        getUrl: "/downloads/UtaPriMovieZoomBG-2.jpg"
    },
    {
        label: "Utano Princesama 2000% Video Conference Background",
        getUrl: "/downloads/UtaPriS2ZoomBG-1.jpg"
    },
]